var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6667 13.9089C25.6488 11.6054 24.9494 9.35879 23.6566 7.4522C22.3638 5.5456 20.5355 4.06438 18.4022 3.19526C16.2689 2.32613 13.926 2.108 11.6689 2.56836C9.41179 3.02871 7.34149 4.14695 5.71894 5.78212C4.09639 7.41729 2.99423 9.49619 2.55137 11.7568C2.10851 14.0174 2.34479 16.3585 3.23042 18.485C4.11604 20.6115 5.61138 22.4283 7.52794 23.7063C9.44449 24.9843 11.6965 25.6663 14.0001 25.6663V24.1886C12.1352 24.1933 10.3044 23.6887 8.7053 22.7292C7.10617 21.7698 5.7994 20.3918 4.92599 18.7441L7.97228 18.2126L7.00006 12.4312L3.88895 12.9367C4.14366 10.4184 5.3243 8.08433 7.20201 6.38696C9.07971 4.68959 11.5207 3.74982 14.0519 3.74982C16.5831 3.74982 19.0241 4.68959 20.9018 6.38696C22.7795 8.08433 23.9602 10.4184 24.2149 12.9367L21.0778 12.4182L20.0667 18.2126L24.7593 19.0423L25.6538 13.9738L25.6667 13.9089ZM5.82043 14.1163L6.32599 17.033L4.49821 17.3571L3.99265 14.4404L5.82043 14.1163ZM23.5797 17.3441L21.7519 17.033L22.2704 14.1163L24.0852 14.4404L23.5797 17.3441Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIcon);
export default __webpack_public_path__ + "static/media/supportIcon.ff692be68e65b6927c9dbfceb5d69614.svg";
export { ForwardRef as ReactComponent };